import { useIntl } from "react-intl";
import React from "react";
import NotasContainer from "./notas.container";

function NotasContainerIntl() {
    const intl = useIntl()
    return (
        <NotasContainer intl={intl}></NotasContainer>
    );
  }

  export default NotasContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/notas/notas.intl.js